//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import arrayToTree from 'array-to-tree';
import zkTable from 'vue-table-with-tree-grid';

export default {
    name: 'workOrderSetting',
    components: {
        zkTable
    },
    data() {
        return {
            loading: false,
            nodes: [],
            node: {
                id: 0,
                nodeName: '',
                nodeType: 1,
                parentId: 0
            },
            rules: {
                nodeName: [{ required: true, message: '请输入名称', trigger: 'blur' }]
                // unit: [{ required: true, type: 'number', message: '请选择时间单位', trigger: 'change' }],
                // timeValue: [{ required: true, type: 'number', message: '请输入所需时间', trigger: 'blur' }]
            },
            showNodeEditModel: false,
            saving: false,
            buttonProps: {
                type: 'default',
                size: 'small'
            },
            units: [
                {
                    title: '小时',
                    value: 0
                },
                {
                    title: '天',
                    value: 1
                }
            ],
            columns: [
                {
                    label: '栏目名称',
                    prop: 'nodeName',
                    width: '400px'
                    // align: 'center'
                },
                // {
                //     label: '栏目索引',
                //     prop: 'nodeIndexes',
                //     minWidth: '50px'
                // },
                {
                    label: '时限',
                    prop: 'timeValue',
                    template: 'timeValue',
                    type: 'template'
                    // align: 'center'
                },
                {
                    label: '单位',
                    prop: 'unitStr',
                    template: 'unitStr',
                    type: 'template'
                    // align: 'center'
                },
                {
                    label: '操作',
                    prop: 'id',
                    minWidth: '200px',
                    type: 'template',
                    template: 'action'
                    // align: 'center'
                }
            ],
            props: {
                stripe: true,
                border: true,
                showHeader: true,
                showSummary: false,
                showRowHover: true,
                showIndex: false,
                treeType: true,
                isFold: true,
                expandType: false,
                selectionType: false
            }
        };
    },
    methods: {
        getNodeList() {
            this.loading = true;
            this.$store.dispatch({
                type: 'node/getAllNodes',
                data: {
                    nodeType: 1
                }
            }).then(() => {
                this.nodes = [];
                let result = this.$store.state.node.nodes;
                this.nodes = result;
                this.nodes.forEach(item => {
                    item.expand = true;
                    item.render = (h, { root, node, data }) => {
                        return h('span', {
                            style: {
                                display: 'inline-block',
                                width: '100%'
                            }
                        }, [
                            h('span', [
                                h('Icon', {
                                    props: {
                                        type: 'ios-folder-outline'
                                    },
                                    style: {
                                        marginRight: '8px'
                                    }
                                }),
                                h('span', data.title)
                            ]),
                            h('span', {
                                style: {
                                    display: 'inline-block',
                                    float: 'right',
                                    marginRight: '32px'
                                }
                            }, [
                                h('Button', {
                                    props: Object.assign({}, this.buttonProps, {
                                        icon: 'ios-add',
                                        type: 'primary'
                                    }),
                                    style: {
                                        width: '64px'
                                    },
                                    on: {
                                        click: () => {
                                            this.append(data);
                                        }
                                    }
                                })
                            ])
                        ]);
                    };
                    // item.expand = true;
                });
                this.nodes = arrayToTree(this.nodes, {
                    parentProperty: 'parentId',
                    customID: 'id'
                });


            }).finally(() => {
                this.loading = false;
            });
        },
        renderContent(h, { root, node, data }) {
            return h('span', {
                style: {
                    display: 'inline-block',
                    width: '100%'
                }
            }, [
                h('span', [
                    h('Icon', {
                        props: {
                            type: 'ios-paper-outline'
                        },
                        style: {
                            marginRight: '8px'
                        }
                    }),
                    // h('span', data.title)
                    h('span', data.title + '(' + data.timeValue + data.unitStr + ')')
                ]),
                h('span', {
                    style: {
                        display: 'inline-block',
                        float: 'right',
                        marginRight: '32px'
                    }
                }, [
                    h('Button', {
                        props: Object.assign({}, this.buttonProps, {
                            icon: 'ios-add'
                        }),
                        style: {
                            marginRight: '8px'
                        },
                        on: {
                            click: () => {
                                this.append(data);
                            }
                        }
                    }),
                    h('Button', {
                        props: Object.assign({}, this.buttonProps, {
                            icon: 'ios-create'
                        }),
                        style: {
                            marginRight: '8px'
                        },
                        on: {
                            click: () => {
                                this.edit(data);
                            }
                        }
                    }),
                    h('Button', {
                        props: Object.assign({}, this.buttonProps, {
                            icon: 'ios-remove'
                        }),
                        on: {
                            click: () => {
                                this.remove(root, node, data);
                            }
                        }
                    })
                ])
            ]);
        },
        append(data) {
            this.node = {};
            this.node.nodeType = data.nodeType;
            this.node.parentId = data.id;
            this.showNodeEditModel = true;
            // const children = data.children || [];
            // children.push({
            //     title: 'appended node',
            //     expand: true
            // });
            // this.$set(data, 'children', children);
        },
        edit(data) {
            // console.log(data);
            this.node = {};
            this.node = JSON.parse(JSON.stringify(data));
            ;
            this.showNodeEditModel = true;
        },
        remove(root, node, data) {
            var vm = this;
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除"' + data.title + '"吗？',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: async () => {
                    await this.$store.dispatch({
                        type: 'node/delNode',
                        id: data.id
                    }).then(() => {
                        this.$Notice.success({
                            duration: 3,
                            title: '删除成功'
                        });
                        vm.getNodeList();
                    }).finally(() => {

                    });

                }
            });

            // const parentKey = root.find(el => el === node).parent;
            // const parent = root.find(el => el.nodeKey === parentKey).node;
            // const index = parent.children.indexOf(data);
            // parent.children.splice(index, 1);
        },
        onSave() {
            this.$refs.nodeForm.validate(async (val) => {
                if (val) {
                    this.saving = true;
                    this.$store.dispatch({
                        type: 'node/saveNode',
                        data: this.node
                    }).then(() => {
                        this.showNodeEditModel = false;
                        this.getNodeList();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        expand() {
            this.nodes.forEach((item) => item.expand = true);
            this.nodes = arrayToTree(this.nodes, {
                parentProperty: 'parentId',
                customID: 'id'
            });
        },
        onToggleExpand(data) {
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    created() {
        this.getNodeList();
    }
};
